import { render } from "./WatchNow.vue?vue&type=template&id=73c956c9"
import script from "./WatchNow.vue?vue&type=script&lang=js"
export * from "./WatchNow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__